import { AlertTemplateProps, AlertProviderProps, positions } from 'react-alert';

const AlertTemplate = ({ message, options, style, close }: AlertTemplateProps) => {
  const icon =
    options.type === 'info'
      ? 'fa-info-circle'
      : options.type === 'success'
      ? 'fa-check-circle'
      : options.type === 'error'
      ? 'fa-times-circle'
      : '';
  const color =
    options.type === 'info'
      ? 'info'
      : options.type === 'success'
      ? 'success'
      : options.type === 'error'
      ? 'danger'
      : '';

  return (
    <div style={{ ...style }} className={`alert alert-${color} px-3 py-1`}>
      <i className={`fas ${icon}`} />
      <span className='mx-3' style={{ flex: 1 }}>
        {message}
      </span>
      <button type='button' className={`align-self-start btn ml-3 text-${color}`} onClick={close}>
        <span aria-hidden='true'>&times;</span>
      </button>
    </div>
  );
};

export const AlertOptions: AlertProviderProps = {
  template: AlertTemplate,
  timeout: 10000,
  position: positions.BOTTOM_CENTER,
  containerStyle: { zIndex: 1051 }
};
